import preset1 from "./backgrounds/preset_BKGND_1.png";
import preset2 from "./backgrounds/preset_BKGND_2.png";
import preset3 from "./backgrounds/preset_BKGND_3.png";
import preset4 from "./backgrounds/preset_BKGND_4.png";
import preset5 from "./backgrounds/preset_BKGND_5.png";
import preset6 from "./backgrounds/preset_BKGND_6.jpg";

export const INSTRUCTOR_COVER_PRESETS = [
    { id: "preset-1", src: preset1, label: "Cover option 1" },
    { id: "preset-2", src: preset2, label: "Cover option 2" },
    { id: "preset-3", src: preset3, label: "Cover option 3" },
    { id: "preset-4", src: preset4, label: "Cover option 4" },
    { id: "preset-5", src: preset5, label: "Cover option 5" },
    { id: "preset-6", src: preset6, label: "Cover option 6" },
];
